const _ = require('lodash');

export const finderCountry = function (cityCode, cities) {
  return _.find(cities, (city) => city.Code === cityCode);
};
